import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import styled from "styled-components";
import { Icon } from "@iconify/react";
import { useDispatch, useSelector } from "react-redux";
import { fetchGeneralPage } from "../Redux/slice/homeSlice";
import { API_URL } from "../Api";


const NavRap = styled.div`
  nav {
    position: fixed;
    top: 0;
    inset: 0;
    z-index: 9999;

    height: 80px !important;
    display: flex;
    align-items: center;
    justify-content: space-between;
    transition: all 0.3s ease-in-out;
  }

  /* default navbar (before scroll) */
  /* nav.nav-default {
    max-width: calc(100% - 60px);
    margin: 25px;
    border-radius: 100px;
    width: 100%;
    overflow: hidden;
    box-shadow: none;
  } */

  /* navbar when scrolled */
  /* nav.nav-scrolled {
    width: 100%;
    margin: 0;
    border-radius: 0;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  } */
  .bg-white {
    background-color: white;
  }

  .contact-link {
    width: 127px;
    height: 47px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #38bdf8;
    color: #1a365d;
    font-size: 15px;
    font-weight: 500;
    text-decoration: none;
    border-radius: 100px;
  }
  .contact-link:hover {
    background: #1a365d;
    color: #38bdf8;
  }
  .bg-transparent {
    background: transparent;
  }

  .bg-white .nav-link {
    color: #000000 !important;
  }
  .navbar {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .nav-down-left-two {
    display: flex;
    align-items: center;
    gap: 5px;
  }
  .nav-down-left {
    display: flex;
    align-items: center;
    gap: 15px;
  }
  .nav-link {
    text-decoration: none;
    color: #000000cc;
    font-size: 15px;
    padding: 10px 15px;
    border-radius: 100px;
    font-weight: 500;
    padding-bottom: 10px;
  }
  .white-link {
    color: #ffffff !important;
  }
  .nav-link:hover {
    background: #d0ceceff;
    color: #1a365d;
  }
  .nav-link.active {
    background: #d0ceceff;
    color: #1a365d !important;
  }

  .nav-mobile {
    display: none;
    cursor: pointer;
  }

  .nav-down {
    background: #ffffff;
    padding: 16px 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .nav-down-left img {
    width: 150px;
    height: 40px;
  }

  .login-us {
    color: #00001c;
    font-size: 15px;
    font-weight: 500;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-decoration: none;
  }

  .register-us {
    text-decoration: none;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #1a365d;
    width: 48px;
    height: 48px;
    border-radius: 100px;
    transition: color 0.3s ease;
  }

  .register-us svg {
    color: #ffffff;
  }

  .register-us:hover svg {
    color: #38bdf8;
  }

  .side-bar {
    display: none !important;
  }

  .nav-down-right {
    display: flex;
    align-items: center;
    gap: 15px;
  }
  .call-side h4 {
    font-size: 16px;
    font-weight: 600;
    color: #000000;
  }
  .call-side {
    font-size: 16px;
    font-weight: 600;
    color: #8a8a8a;
  }
  .call-side {
    display: flex;
    align-items: center;
    gap: 5px;
  }
  .contact-mobile {
    display: none;
  }

  .dropdown-container {
    position: fixed;
    width: 100vw;
    height: 100vh;
    display: flex;

    justify-content: flex-end;
    align-items: flex-start;
    background: rgba(0, 0, 0, 0.3); /* Semi-transparent dark background */
    backdrop-filter: blur(1px); /* Adds a blur effect */
    z-index: 10000;
    top: 0;
    right: 0;
  }
  .contact-pop {
    background: linear-gradient(0deg, #ffffff 0%, #f6f5f2 20%);
    padding: 20px;
    border-top-left-radius: 24px;
    border-bottom-left-radius: 24px;
    height: 100vh;
  }
  .contact-pop-circle-all {
    display: flex;
    justify-content: flex-end;
  }
  .contact-pop-circle {
    width: 50px;
    height: 50px;
    cursor: pointer;
    background: #ffffff;
    border-radius: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .contact-pop img {
    width: 200px;
    height: 200px;
  }
  .contact-pop h3 {
    font-size: 30px;
    font-weight: 500;
    color: #1a365d;
    margin: 0px;
  }
  .contact-pop p {
    font-weight: 400;
    color: #000000cc;
    font-size: 16px;
    max-width: 300px;
    line-height: 19px;
  }

  .contact-pop-btn {
    color: #f6f5f2;
    background: #1a365d;
    text-decoration: none;
    height: 47px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 500;
    font-size: 15px;
    border-radius: 24px;
    width: 183px;
  }
  .contact-pop-inner-circle {
    height: 47px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 47px;
    background: #1a365d;
    border-radius: 100px;
  }
  .contact-pop-inner-circle svg {
    color: #38bdf8;
  }
  .contact-pop-inner {
    display: flex;
    cursor: pointer;
  }
  .contact-pop-inner:hover .contact-pop-inner-circle {
    background: #38bdf8;
  }

  .contact-pop-inner:hover .contact-pop-inner-circle svg {
    color: #1a365d;
  }
  .contact-pop-inner:hover .contact-pop-btn {
    background: #38bdf8;
    color: #1a365d;
  }
  .all-contact-pop {
    padding-right: 20px;
    display: flex;
    flex-direction: column;
    gap: 25px;
    margin-top: 10px;
  }
  .contact-pop-circle svg {
    color: #1a365d;
  }
  .contact-pop-circle:hover .contact-pop-circle svg {
    color: #38bdf8;
  }
  .contact-pop-circle:hover {
    background: #38bdf8;
  }
  @media (max-width: 1250px) {
    .call-side {
      display: none;
    }
  }
  /* Mobile Styles */
  @media (max-width: 1024px) {
    .navbar {
      flex-direction: column;
      align-items: flex-start !important;
      justify-content: flex-start !important;
      position: fixed;
      top: 80px;
      left: -360px;
      width: 298px;
      height: 100vh;
      background: white;
      color: black;
      box-shadow: 0 40px 60px rgba(0, 0, 0, 0.1);
      padding: 40px 0 0 30px;
      transition: 0.3s ease-in-out;
      z-index: 9999;
    }
    .white-link {
      color: #000000cc !important;
    }
    .navbar.active {
      left: 0px;
    }

    .nav-mobile {
      display: block;
    }

    .nav-down {
      padding: 16px 30px;
    }
    nav.nav-default {
      border-radius: 10px !important;
    }
  }

  @media (max-width: 500px) {
    .nav-down {
      padding: 16px 10px;
    }

    .side-bar {
      display: flex !important;
    }
    .inner-bar {
      display: none !important;
    }
    .contact-mobile {
      display: block;
    }
    .all-contact-pop {
      gap: 15px;
      margin-top: 10px;
      padding-right: 10px;
    }
    .contact-pop {
      padding: 10px;
    }
    .contact-link {
      display: none;
    }
  }
  @media (max-width: 360px) {
    .navbar {
      width: 280px;
    }
  }
`;

const Nav = () => {
  const [clicked, setClicked] = useState(false);
  const [activeLink, setActiveLink] = useState("home");
  const [contactDrop, setContactDrop] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const dispatch = useDispatch();

  const { contactObject, generalObject } = useSelector(
    (state) => state.content,
  );
  //  console.log(generalObject);

  const websetting = generalObject?.data?.websetting;

  useEffect(() => {
    dispatch(fetchGeneralPage());
  }, [dispatch]);

  const handleClick = () => {
    setClicked(!clicked);
  };

  const handleLinkClick = (link) => {
    setActiveLink(link);
    setClicked(!clicked); // close mobile menu
  };

  const { pathname } = useLocation();

  useEffect(() => {
    setClicked(false);
    window.scrollTo(0, 0); // Scroll to top on route change
  }, [pathname]);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 30); // scrolled state
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <NavRap>
      <nav className={`containers ${scrolled ? "bg-white" : "bg-transparent"}`}>
        <div className="nav-down-left">
          <div className="nav-mobile" onClick={handleClick}>
            {clicked ? (
              <Icon
                width="30px"
                height="30px"
                icon="uil:times"
                style={{ color: "black" }}
              />
            ) : (
              <Icon
                width="30px"
                height="30px"
                icon="mdi-light:menu"
                style={{ color: "black" }}
              />
            )}
          </div>
          <img
            src={`${
              pathname === "/"
                ? scrolled
                  ? `${API_URL}/${websetting?.logo_url}`
                  : `${API_URL}/${websetting?.logo_two}`
                : `${API_URL}/${websetting?.logo_url}`
            }`}
            alt="Logo"
          />
        </div>

        <div className="nav-down-right">
          <div className={clicked ? "navbar active" : "navbar"} id="navbar">
            <Link
              className={`nav-link ${pathname === "/" && "white-link"}  ${activeLink === "home" ? "active" : ""}`}
              to="/"
              onClick={() => handleLinkClick("home")}
            >
              Home
            </Link>
            <Link
              className={`nav-link ${pathname === "/" && "white-link"} ${activeLink === "about" ? "active" : ""}`}
              to="/about"
              onClick={() => handleLinkClick("about")}
            >
              About us
            </Link>

            <Link
              className={`nav-link ${pathname === "/" && "white-link"}  ${
                activeLink === "services" ? "active" : ""
              }`}
              to="/services"
              onClick={() => handleLinkClick("services")}
            >
              Services
            </Link>
            <Link
              className={`nav-link ${pathname === "/" && "white-link"}  ${activeLink === "blog" ? "active" : ""}`}
              to="/insights"
              onClick={() => handleLinkClick("blog")}
            >
              Insights
            </Link>
            <Link
              className={`nav-link ${pathname === "/" && "white-link"}  ${activeLink === "teams" ? "active" : ""}`}
              to="/testimonials"
              onClick={() => handleLinkClick("teams")}
            >
              Testimonials
            </Link>

            <Link
              className={`contact-mobile nav-link  ${pathname === "/" && "white-link"}  ${activeLink === "contact" ? "active" : ""}`}
              to="/contact"
              onClick={() => handleLinkClick("contact")}
            >
              Contact Us
            </Link>
            {/* <Link
                className={`nav-link ${
                  activeLink === "contact" ? "active" : ""
                }`}
                to="/contact"
                onClick={() => handleLinkClick("contact")}
              >
                Contact us
              </Link> */}
            {/* <Link to="/login" className="register-us side-bar">
                Login
              </Link> */}
          </div>
        </div>

        <div className="nav-down-right">
          {/* <div className="call-side">
              <h4>Call Us:</h4>
              <p>{websetting?.biz_phone}</p>
            </div> */}
          <Link
            className={`contact-link ${
              activeLink === "contact" ? "active" : ""
            }`}
            to="/contact"
            onClick={() => handleLinkClick("contact")}
          >
            Contact us
          </Link>
          <Link onClick={() => setContactDrop(true)} className="register-us">
            <Icon
              width="30px"
              height="30px"
              icon="sidekickicons:dots-3x3"
              style={{ color: "white" }}
            />
          </Link>
        </div>
        {contactDrop ? (
          <>
            <div className="dropdown-container">
              <div className="contact-pop">
                <div className="contact-pop-circle-all">
                  <div
                    onClick={() => setContactDrop(false)}
                    className="contact-pop-circle"
                  >
                    <Icon
                      width="30px"
                      height="30px"
                      icon="uil:times"
                      style={{ color: "black" }}
                    />
                  </div>
                </div>
                <div className="all-contact-pop">
                  <img src="/images/star-3.png" alt="" />
                  <h3>Contact us</h3>
                  <p>{websetting?.first_address}</p>

                  <p>{websetting?.biz_email}</p>
                  <p>{websetting?.biz_phone}</p>
                  <div className="contact-pop-inner">
                    <Link to="/contact" className="contact-pop-btn">
                      Get in Touch Today
                    </Link>
                    <div className="contact-pop-inner-circle">
                      <Icon
                        width="30px"
                        height="30px"
                        icon="gg:arrow-top-right"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          ""
        )}
      </nav>
    </NavRap>
  );
};

export default Nav;
